var render = function render(){var _vm=this,_c=_vm._self._c;return _c('search-bar',{staticClass:"promo-search-bar",attrs:{"ctas":_vm.ctas,"show-geo-location":true},on:{"browse":function($event){return _vm.compare()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }